import React from 'react';
import { useGame } from '../../contexts/GameContext';
import './NotificationSystem.css';

const NotificationSystem: React.FC = () => {
  const { state } = useGame();

  return (
    <div className="notification-container">
      {state.notifications.map(notification => (
        <div
          key={notification.id}
          className={`notification notification-${notification.type}`}
        >
          <div className="notification-content">
            {notification.message}
          </div>
        </div>
      ))}
    </div>
  );
};

export default NotificationSystem;
